export default "__VITE_ASSET__DqA138GS__"